import http from "../http-common";
import authHeader from "../../services/auth-header";

const getTotals = () => {
  return http.get("/dashboard/totals", { headers: authHeader() });
};

const getAll = (params) => {
  return http.get("/reconciliation", { headers: authHeader(), params });
};

const create = (data) => {
  return http.post("/reconciliation", data, { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/reconciliation/${id}`, { headers: authHeader() });
};

const getMonthlyCycleSummary = (params) => {
  return http.get("/reconciliation/monthly-cycle-summary", { headers: authHeader(), params });
};

const saveBankReconciliation = (data) => {
  return http.post("/reconciliation/bank-reconciliation", data, { headers: authHeader() });
};

const getBankReconciliations = (params) => {
  return http.get("/reconciliation/bank-reconciliations", { headers: authHeader(), params });
};

const ReconciliationService = {
  getTotals,
  getAll,
  create,
  remove,
  getMonthlyCycleSummary,
  saveBankReconciliation,
  getBankReconciliations,
};

export default ReconciliationService;
